import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

//COMPONENTS
import StyleMenu from "./files/styleMenu";

//STYLE COMPONENTS
import SlideShowConfig from "../components/slider/admin/config";
import SimpleSectionCenteredTextConfig from "../components/simpleSectionCenteredText/admin/config";
import HalfPhotoAdmin from "../components/halfPhoto/admin/config";
import ReviewsInColumnsAdmin from "../components/reviewsInColumns/admin/config";
import BannerSectionsAdmin from "../components/bannerSections/admin/config";
import FourSectionsOneRowAdmin from "../components/fourSectionsOneRow/admin/config";
import PhotoRowAdmin from "../components/photoRow/admin/config";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<StyleMenu />} />
                        <Route path="/slider" element={<SlideShowConfig />} />
                        <Route path="/simpleSectionCentredText" element={<SimpleSectionCenteredTextConfig />} />
                        <Route path="/halfPhoto" element={<HalfPhotoAdmin />} />
                        <Route path="/reviewsInColumns" element={<ReviewsInColumnsAdmin />} />
                        <Route path="/fourSectionsOneRow" element={<FourSectionsOneRowAdmin />} />
                        <Route path="/bannerSections" element={<BannerSectionsAdmin />} />
                        <Route path="/photoRow" element={<PhotoRowAdmin />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
